import React from "react";
import { OtpInputProps } from "./index.interface";
import OtpInput from "react-otp-input";
import styles from "./index.module.scss";

const OtpInputC = ({
  value,
  onChange,
  numInputs,
  renderInput,
  inputStyle,
  renderSeparator
}: OtpInputProps) => {
  return (
    <div className={styles.otpWrap}>
      <OtpInput
        value={value}
        onChange={onChange}
        numInputs={numInputs}
        inputStyle={inputStyle}
        renderInput={renderInput}
        shouldAutoFocus
        renderSeparator={renderSeparator}
        inputType="tel"
      />
    </div>
  );
};

export default OtpInputC;
